import type { ReactNode } from 'react';
import { useCEAuthStore } from '../auth/store';
import { LoginPage } from '../pages/LoginPage';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: Readonly<AuthGuardProps>) {
  const isAuthenticated = useCEAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
